import { render, staticRenderFns } from "./BookTabs.vue?vue&type=template&id=546769db&"
import script from "./BookTabs.vue?vue&type=script&lang=js&"
export * from "./BookTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports